import "./styles.less";

import React, { FC } from "react";
import { Skeleton, Typography } from "antd";
import { DescriptionProps, useDescription } from "./Description.hook";

export const Description: FC<DescriptionProps> = props => {

	const {
		limitLength,
		hideInformation,
		expandable,
		description,
		showTitle,
		loading,
	} = useDescription(props);

	const ellipsis = hideInformation
		? { rows: limitLength, expandable: expandable, symbol: "Ver Más" }
		: false;

	const formatDescription = (text: string) => {
		const regex = /<[^>]*(>|$)| |‌|»|«|>/g;
		return text.replace(regex, ' ').split(/\n/gm).map(
			line => line.trim() !== '' ? line.trim() : ''
		).join('\n').trim();
	};

	return (
		<>
			{description && (
				<>
					{showTitle && <Typography.Title level={4}>Descripción</Typography.Title>}
					{loading ? (
						<Skeleton active />
					) : (
						<Typography.Paragraph
							className={"property-description"}
							ellipsis={ellipsis}>
							<span style={{ whiteSpace: 'pre-wrap' }}>
								{formatDescription(description)}
							</span>
						</Typography.Paragraph>
					)}
				</>
			)}
		</>
	);
};
